

import copy from 'copy-to-clipboard';
import { Loader, Upload, FileText } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import Button from '../../../../components/Button';
import { week } from '../../../../components/CommonDataGrid/MockData';
import ConfirmationDialog from '../../../../components/DialogBox';
import CustomDropdown from '../../../../components/DropDown';
import ModernTable from '../../../../components/ModernTable';
import { LeadColumnDef } from '../../../../components/ModernTable/types';
import Tabs from '../../../../components/Tabs';
import ClientIcon from '../../../../images/SideBar/Client';
import EditImg from '../../../../images/SideBar/Edit';
import EmailIcon from '../../../../images/SideBar/EmailIcon';
import ShareIcon from '../../../../images/SideBar/Share';
import ViewFileImg from '../../../../images/SideBar/viewFile';
import { apiPaths } from '../../../../service/apiPaths';
import ApiService from '../../../../service/ApiService';
import { leadStyes, Roles } from '../../../../util/constant';
import { ILead, IService, IUsers } from '../Lead.props';
import useLead from '../useLead';
import ConvertToClientModal from './ConvertToClientModal';
import EditLeadIndex from './EditLead';
import EmailModal from './EmailModal';
import GraphLead from './GraphLead';
import MyLeads from './MyLeads';
import BdeForm from '../BDE-Form/BdeForm';
import Modal from '../../../../components/Model';
import Goals from './Goals';
import LeadTracker from './LeadTracker';
import Calendar from '../../../../page/Calendar/Calendar';
import { RefreshCw } from 'lucide-react';

const DEFAULT_CSV_FIELDS = [
  "No",
  "LEADID",
  "SERVICES",
  "DESCRIPTION",
  "EMAIL",
  "PHONE",
  "Lead Web Link",
];

const Lead: React.FC = () => {
  const Role = localStorage.getItem("role");
  const currentSubRole = localStorage.getItem("subRole");
  const navigate = useNavigate();
  const [isReminderPopupOpen, setIsReminderPopupOpen] = useState(false);
  const [selectedReminderDate, setSelectedReminderDate] = useState<Date | null>(
    null
  );
  const [selectedLeadForReminder, setSelectedLeadForReminder] = useState<
    ILead | null
  >(null);
  const [selectedLeadForContact, setSelectedLeadForContact] = useState<
    string | null
  >(null);

  // Enhanced reminder form state
  const [reminderForm, setReminderForm] = useState({
    title: '',
    description: '',
    followupDateTime: '',
    followupNotes: '',
    assignedTo: '',
    projectId: ''
  });
  const [creatingReminder, setCreatingReminder] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [projects, setProjects] = useState<any[]>([]);

  // Date filter state - using the one from useLead hook

  // Modal state for Add to Sequences
  const [isSequenceModalOpen, setIsSequenceModalOpen] = useState(false);
  // const [sequenceOptions, setSequenceOptions] = useState<any[]>([]);
  const [selectedSequence, setSelectedSequence] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [modalLead, setModalLead] = useState<any>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalFields, setModalFields] = useState({
    first_name: "",
    last_name: "",
    organization_name: "",
    title: "",
    email: "",
    website_url: "",
    direct_phone: "",
    corporate_phone: "",
  });

  // State for Convert to Client Modal
  const [isConvertToClientModalOpen, setIsConvertToClientModalOpen] =
    useState(false);
  const [selectedLeadForConversion, setSelectedLeadForConversion] =
    useState<ILead | null>(null);

  // State for Description Popup Modal
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState<string>("");

  const {
    selectedLeadId,
    leadData,
    showConfirmation,
    showDeleteConfirmation,
    handleCancelStatusUp,
    updateScreen,
    handleConfirmStatusUp,
    handleEdit,
    handleAdd,
    handleStatusUp,
    handleDateFilter,
    setSearch,
    search,
    setPage,
    page,
    loading,
    totalPage,
    openEmailModal,
    handleSendEmail,
    handleSendComment,
    handleSelectStatus,
    selectedRows,
    isEmailModalOpen,
    setIsEmailModalOpen,
    setSelectedLeadForEmail,
    selectedLeadForEmail,
    sortValue,
    setSortValue,
    handleDeleteLead,
    handleConfirmDelete,
    handleCancelDelete,
    handleDownloadCSV,
    handleConfirmDownload,
    handleCancelDownload,
    csvStartDate,
    setCsvStartDate,
    csvEndDate,
    setCsvEndDate,
    leadCount,
    handleRemainder,
    isDownloadModalOpen,
    todayCount,
    handleContactLead,
    handleReminderToggle,
    // fetchServicesData,
    // fetchAllServices,
    // refreshServices,
    services,
    userId,
    platforms,
    setPlatforms,
    user,
    setLeadData,
    clearFilters,
    setUserId,
    dateFilter,
    setDateFilter,
    handleUpdateContact,
    fetchPlatformsData,
    handleImportCsv,
    importLoading,
  } = useLead();
  let isBg = false;
  const sequences = JSON.parse(localStorage.getItem("sequences") || "[]");

  // Ensure platforms are loaded when component mounts
  useEffect(() => {
    if (!platforms || platforms.length === 0) {
      fetchPlatformsData("platform");
    }
  }, [platforms, fetchPlatformsData]);

  // Debug: Log sample lead data to understand structure
  // useEffect(() => {
  //   if (leadData && leadData.length > 0) {
  //     console.log("Sample lead data:", leadData[0]);
  //     console.log("Sample lead platform:", leadData[0]?.platform);
  //   }
  // }, [leadData]);
  const userNames = [
    {
      id: "686a4b9d696fbc000d5ee061",
      name: "Nimisha",
      email: "",
    },
    {
      id: "686a4b9d696fbc000d5ee061",
      name: "Priyal",
      email: "",
    },
  ];

  const [selectedCreator, setSelectedCreator] = useState<string>("");
  const [selectedService, setSelectedService] = useState<string>("");
  const [serviceOptions, setServiceOptions] = useState<string[]>([]);
  const [selectedAttendBy, setSelectedAttendBy] = useState<string>("");
  const [platform, setPlatform] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [importResults, setImportResults] = useState<any>(null);
  const [importStep, setImportStep] = useState<
    "upload" | "preview" | "confirm"
  >("upload");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewData, setPreviewData] = useState<Record<string, string>[]>([]);

  const handleStatusChange = (e: any, params: any) => {
    const status = e.target.value;
    if (status === "Reminder") {
      setSelectedLeadForReminder(params.row);
      // Pre-fill the reminder form with lead data
      setReminderForm({
        title: `Follow-up: ${params.row.name}`,
        description: `Follow-up reminder for lead: ${params.row.name}${params.row.companyName ? ` (${params.row.companyName})` : ''}\nLinkedIn: ${params.row.linkedin || 'N/A'}\nLead Link: https://task.blisslers.com/lead/${params.row._id}`,
        followupDateTime: '',
        followupNotes: `Lead Status: ${params.row.leadStatus}\nService: ${params.row.services?.type || 'N/A'}\nPlatform: ${params.row.platform?.name || 'N/A'}`,
        assignedTo: params.row.connectedId?._id || '',
        projectId: ''
      });
      setIsReminderPopupOpen(true);
    } else {
      handleSelectStatus(e, params.row);
    }
  };

  const openImportModal = () => {
    setIsImportModalOpen(true);
    setImportResults(null);
  };
  const closeImportModal = () => {
    setIsImportModalOpen(false);
    setImportResults(null);
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      previewCsvFile(file);
    }
  };

  const previewCsvFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const csv = e.target?.result as string;
        const lines = csv.split("\n");
        const headers = lines[0]
          .split(",")
          .map((h) => h.trim().replace(/"/g, ""));
        const data = lines.slice(1, 6).map((line) => {
          const values = line.split(",").map((v) => v.trim().replace(/"/g, ""));
          const row: any = {};
          headers.forEach((header, index) => {
            row[header] = values[index] || "";
          });
          return row;
        });
        setPreviewData(data);
        setImportStep("preview");
      } catch (error) {
        toast.error("Error reading CSV file");
      }
    };
    reader.readAsText(file);
  };

  const handleImport = async () => {
    if (!selectedFile) return;
    try {
      if (previewData.length > 0) {
        const headers = Object.keys(previewData[0]);
        const required = ["linkedin", "email", "companyName", "description", "leadStatus"];
        const missing = required.filter((h) => !headers.includes(h));
        if (missing.length > 0) {
          toast.error(`Missing required fields: ${missing.join(", ")}`);
          return;
        }
      }

      await handleImportCsv(selectedFile);
      setImportStep("upload");
      setSelectedFile(null);
      setPreviewData([]);
      closeImportModal();
    } catch (error) {
      console.error("Import failed:", error);
    }
  };

  // Enhanced reminder submission that creates calendar task
  const handleReminderSubmit = async () => {
    if (!selectedReminderDate || !selectedLeadForReminder) {
      toast.error('Please select a reminder date and ensure lead is selected');
      return;
    }

    if (!reminderForm.title || !reminderForm.description) {
      toast.error('Please fill in title and description');
      return;
    }

    setCreatingReminder(true);
    try {
      const currentUser = {
        userId: localStorage.getItem("userId"),
        role: localStorage.getItem("role")
      };

      // Create calendar task data
      const eventData = {
        title: reminderForm.title,
        description: reminderForm.description,
        dueDate: selectedReminderDate.toISOString(),
        followupDateTime: reminderForm.followupDateTime || selectedReminderDate.toISOString(),
        followupNotes: reminderForm.followupNotes,
        assignedTo: reminderForm.assignedTo || currentUser.userId,
        createdBy: currentUser.userId,
        projectId: reminderForm.projectId,
        status: 'pending',
        leadId: selectedLeadForReminder._id, // Link to the lead
        leadName: selectedLeadForReminder.name,
        leadCompany: selectedLeadForReminder.companyName,
        leadEmail: selectedLeadForReminder.email,
        leadPhone: selectedLeadForReminder.phone
      };

      console.log('Creating calendar reminder with data:', eventData);

      // First, create the event in the database
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.createCalendarTask,
        data: eventData,
      });

      console.log('Calendar reminder created in database:', response);

      // Update the lead status to "Reminder" in the database
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateLead}${selectedLeadForReminder._id}`,
        data: { 
          leadStatus: "Reminder",
          reminderDate: selectedReminderDate.toISOString(),
          calendarTaskId: response._id || response.id // Store reference to calendar task
        },
      });

      // Update local lead data
      setLeadData((prev) => {
        const updated = prev.map((lead) =>
          lead._id === selectedLeadForReminder._id
            ? { 
                ...lead, 
                leadStatus: "Reminder",
                reminderDate: selectedReminderDate.toISOString(),
                calendarTaskId: response._id || response.id
              } as ILead
            : lead
        );
        return updated;
      });

      // Try to create Google Calendar event if available
      let googleCalendarSuccess = false;
      try {
        // Check if Google Calendar is available (you might need to implement this check)
        const gapi = (window as any).gapi;
        if (gapi && gapi.client && gapi.client.getToken()) {
          // Create Google Calendar event
          const googleEvent = {
            'summary': eventData.title,
            'description': `${eventData.description}\n\nLead Details:\nName: ${eventData.leadName}\nCompany: ${eventData.leadCompany}\nEmail: ${eventData.leadEmail}\nPhone: ${eventData.leadPhone}\nLinkedIn: ${selectedLeadForReminder.linkedin || 'N/A'}\n\nFollow-up Notes: ${eventData.followupNotes}`,
            'start': {
              'dateTime': eventData.dueDate,
              'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            'end': {
              'dateTime': new Date(new Date(eventData.dueDate).getTime() + 60 * 60 * 1000).toISOString(), // 1 hour duration
              'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            'reminders': {
              'useDefault': false,
              'overrides': [
                {'method': 'email', 'minutes': 24 * 60}, // 24 hours before
                {'method': 'popup', 'minutes': 30}, // 30 minutes before
              ],
            },
            'colorId': '3', // Orange color for reminders
            'transparency': 'opaque',
          };

          const googleResponse = await gapi.client.calendar.events.insert({
            calendarId: 'primary',
            resource: googleEvent,
            sendUpdates: 'all',
          });

          if (googleResponse.result.id) {
            console.log('Event successfully created in Google Calendar with ID:', googleResponse.result.id);
            googleCalendarSuccess = true;
            
            // Update the calendar task with Google Calendar event ID
            await ApiService({
              method: "PUT",
              endpoint: `${apiPaths.updateCalendarTask}${response._id || response.id}`,
              data: { 
                googleCalendarEventId: googleResponse.result.id 
              },
            });
          }
        }
      } catch (googleError) {
        console.error('Failed to create Google Calendar event:', googleError);
        // Don't fail the whole operation, just log the error
      }

      // Close modal and reset form
      setIsReminderPopupOpen(false);
      setSelectedReminderDate(null);
      setSelectedLeadForReminder(null);
      setReminderForm({
        title: '',
        description: '',
        followupDateTime: '',
        followupNotes: '',
        assignedTo: '',
        projectId: ''
      });

      // Show success message
      if (googleCalendarSuccess) {
        toast.success('Reminder set successfully! Created in both database and Google Calendar.');
      } else {
        toast.success('Reminder set successfully! Created in database. Google Calendar integration not available.');
      }

    } catch (error) {
      console.error("Failed to create reminder:", error);
      toast.error('Failed to create reminder. Please try again.');
    } finally {
      setCreatingReminder(false);
    }
  };

  // Handle reminder form input changes
  const handleReminderFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setReminderForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Close reminder modal
  const handleCloseReminderModal = () => {
    setIsReminderPopupOpen(false);
    setSelectedReminderDate(null);
    setSelectedLeadForReminder(null);
    setReminderForm({
      title: '',
      description: '',
      followupDateTime: '',
      followupNotes: '',
      assignedTo: '',
      projectId: ''
    });
  };

  const handleServiceChange = async (event: any, params: any) => {
    const newService = event.target.value;
    try {
      // Update the lead service via API
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateLead}${params.row._id}`,
        data: { serviceActive: newService },
      });

      // Update the local state
      setLeadData((prev) => {
        const updated = prev.map((lead) =>
          lead._id === params.row._id
            ? { ...lead, serviceActive: newService }
            : lead
        );
        return updated;
      });

      // Refresh services to ensure dropdown is up to date
      // refreshServices();

      toast.success("Service updated successfully!");
    } catch (error) {
      console.error("Error updating service:", error);
      toast.error("Failed to update service");
    }
  };

  // Fetch sequences from Apollo API

  // Open modal and set lead data
  const handleOpenSequenceModal = (lead: any) => {
    setModalLead(lead);
    setModalFields({
      first_name: lead.name?.split(" ")[0] || "",
      last_name: lead.name?.split(" ").slice(1).join(" ") || "",
      organization_name: lead.companyName || "",
      title: lead.title || "",
      email: lead.email || "",
      website_url: lead.linkedin || "",
      direct_phone: lead.phone || "",
      corporate_phone: lead.corporate_phone || "",
    });
    setSelectedSequence("");
    setSelectedUser("");
    setIsSequenceModalOpen(true);
  };

  // Handle modal field change
  const handleModalFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setModalFields({ ...modalFields, [e.target.name]: e.target.value });
  };

  // Handle create contact submit
  const handleCreateContact = async () => {
    setIsSubmitting(true);
    try {
      const params = new URLSearchParams({
        ...modalFields,
      }).toString();
      // 1. Create the contact
      const createRes = await ApiService({
        method: "POST",
        endpoint: apiPaths.addContactToCampaign,
        data: {
          ...modalFields,
        },
      });
      // Try to extract contact_id from response
      const contactId = createRes?.contact?.id;
      if (!contactId) {
        toast.error(
          "Contact created, but could not get contact ID for sequence."
        );
        setIsSubmitting(false);
        return;
      }
      // 2. Add contact to sequence
      try {
        // Ensure campaign ID is the same in both URL and query string
        const campaignId = selectedSequence;
        await ApiService({
          method: "POST",
          endpoint: `${apiPaths.getEmailerCampaigns}`,
          data: {
            emailer_campaign_id: campaignId,
            "contact_ids[]": contactId,
            send_email_from_email_account_id: "686a4b9d696fbc000d5ee061",
            sequence_no_email: false,
            sequence_unverified_email: false,
            sequence_job_change: false,
            sequence_active_in_other_campaigns: false,
            sequence_finished_in_other_campaigns: false,
            lead_id: modalLead._id,
          },
        });
        toast.success("Contact created and added to sequence successfully");
        ApiService({
          method: "PUT",
          endpoint: `${apiPaths.updateLead}${modalLead._id}`,
          data: {
            isSequence: true,
          },
        });
        setIsSequenceModalOpen(false);
      } catch (err) {
        toast.error("Contact created, but failed to add to sequence");
      }
    } catch (error) {
      toast.error("Failed to create contact");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle opening the Convert to Client Modal
  const handleOpenConvertToClientModal = (lead: any) => {
    setSelectedLeadForConversion(lead);
    setIsConvertToClientModalOpen(true);
  };

  // Handle closing the Convert to Client Modal
  const handleCloseConvertToClientModal = () => {
    setIsConvertToClientModalOpen(false);
    setSelectedLeadForConversion(null);
  };

  // Helper function to truncate text to 15 words
  const truncateToWords = (text: string, maxWords: number = 15) => {
    if (!text) return "";
    const words = text.split(" ");
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(" ") + "...";
  };

  // Handle opening description modal
  const handleOpenDescriptionModal = (description: string) => {
    setSelectedDescription(description);
    setIsDescriptionModalOpen(true);
  };

  // Handle closing description modal
  const handleCloseDescriptionModal = () => {
    setIsDescriptionModalOpen(false);
    setSelectedDescription("");
  };

  const columns: LeadColumnDef[] = [
    {
      accessorKey: "userId",
      header: "Creator Name",
      size: 120,
      cell: ({ row }) => (
        <div className="flex items-center gap-1 w-full">
          {row.original.isEmailSent === true && (
            <div
              className={`flex items-center group relative ${
                row.original.isEmailSentStatus
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              <EmailIcon />
              <span className="absolute left-7 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                {row.original.isEmailSentStatus
                  ? row.original.messageSent
                  : row.original.error}
              </span>
            </div>
          )}
          <p className="text-wrap text-sm truncate">
            {row.original.userId?.name}
          </p>
        </div>
      ),
    },
    {
      accessorKey: "linkedin",
      header: "Lead Name",
      size: 120,
      cell: ({ row }) => (
        <div
          className={`${
            row.original.platform?.name === "apollo" ? `bg-yellow-300` : ``
          } p-1 rounded-md space-y-2`}
        >
          <a
            className="text-blue-700 border-b-2 border-blue-500 cursor-pointer text-sm "
            href={row.original.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            title={row.original.name}
          >
            {row.original.name}
          </a>
          <p className="text-sm">{row.original.platform?.name}</p>
        </div>
      ),
    },

    {
      accessorKey: "services",
      header: "Services",
      size: 100,
      cell: ({ row }) => {
        const selectedService =
          (row.original.services?.type && row.original.serviceActive) ||
          row.original.services?.type;

        return (
          <div className="bg-blue-300 text-black rounded-md p-1 min-w-20">
            <select
              value={selectedService}
              onChange={(event) =>
                handleServiceChange(event, { row: row.original })
              }
              className="appearance-none bg-transparent outline-none w-full cursor-pointer font-medium text-xs"
            >
              {services && services.length > 0 ? (
                services.map((service: IService) => (
                  <option key={service.id} value={service.type}>
                    {service.type}
                  </option>
                ))
              ) : (
                <>
                  {/* <option value="Mobile">Mobile</option>
                  <option value="Status 2">Status 2</option>
                  <option value="Service">Service</option> */}
                </>
              )}
            </select>
          </div>
        );
      },
    },
    {
      accessorKey: "isSequence",
      header: "Add to Sequences",
      size: 110,
      cell: ({ row }) => (
        <>
          {row.original.isSequence === false ? (
            <button
              className="px-2 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-xs disabled:bg-gray-400"
              onClick={() => handleOpenSequenceModal(row.original)}
            >
              +Seq.
            </button>
          ) : row.original.isSequence === true ? (
            <p className="text-green-600 font-medium h-full w-full flex items-center justify-center text-xs">
              In Sequence
            </p>
          ) : (
            <p className="text-green-600 font-medium bg-green-100 h-full w-full flex items-center justify-center text-xs">
              Not Applicable
            </p>
          )}
        </>
      ),
    },
    // {
    //   accessorKey: "platform",
    //   header: "Platform",
    //   size: 100,
    //   cell: ({ row }) => (
    //     <p className="text-sm">{row.original.platform?.name}</p>
    //   ),
    // },
    {
      accessorKey: "description",
      header: "Description",
      size: 180,
      cell: ({ row }) => {
        const description = row.original.description || "";
        const truncatedDescription = truncateToWords(description);
        const isTruncated = description.split(" ").length > 15;
        
        return (
          <div className="relative group">
            <span 
              className={`max-w-xs text-xs cursor-pointer w-20 transition-colors`}
             
              title={isTruncated ? description : ""}
            >
              {truncatedDescription}
            </span>
            {isTruncated && (
              <div className="absolute bottom-full w-2 left-0 mb-2 px-3 py-2 bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 max-w-xs">
                {description}
                <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
              </div>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "leadStatus",
      header: "Lead Status",
      size: 120,
      cell: ({ row }) => (
        <>
          <div className="space-y-1">
            <select
              value={row.original.leadStatus || "New"}
              onChange={(e) => handleStatusChange(e, { row: row.original })}
              className={`${
                leadStyes[row.original.leadStatus] || "bg-gray-200 "
              } min-w-20`}
            >
              <option value="New">New</option>
              <option value="Send For Review">Send For Review</option>
              <option value="Approved">Approved</option>
              <option value="Skip">Skip</option>
              <option value="Rejected">Rejected</option>
              <option value="Contacted">Connected</option>
              <option value="Converted">Converted</option>
              <option value="Lost">Lost</option>
              <option value="Duplicate">Duplicate</option>
              <option value="Not Interested">Not Interested</option>
              <option value="On Hold">On Hold</option>
              <option value="Reminder">Reminder</option>
              <option value="Follow-Up-1">Follow Up 1</option>
              <option value="Follow-Up-2">Follow Up 2</option>
            </select>
          </div>
        </>
      ),
    },
    {
      accessorKey: "connectedId",
      header: "Attend BY",
      size: 120,
      cell: ({ row }) => (
        <select
          value={row.original.connectedId ? row.original.connectedId._id : ""}
          onChange={(e) => {
            if (e.target.value)
              handleContactLead(row.original._id, e.target.value);
          }}
          className={`px-2 py-1 ${
            row.original.connectedId ? "bg-green-100" : "bg-blue-100"
          } bg-blue-100 text-black rounded-md text-xs`}
        >
          <option value="" className="text-black ">
            Select user
          </option>
          {user &&
            user.map((u: IUsers) =>
              u.id && u.name ? (
                <option key={u.id} value={u.id} className="text-black">
                  {u.name}
                </option>
              ) : null
            )}
        </select>
      ),
    },

    {
      accessorKey: "lookingFor",
      header: "Looking For",
      size: 100,
      cell: ({ row }) => (
        <p className="text-sm truncate">{row.original.lookingFor}</p>
      ),
    },

    {
      accessorKey: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <div className="flex space-x-1 justify-center">
          <button
            onClick={() => handleEdit(row.original._id)}
            className="text-fontColor hover:text-primary-2"
          >
            <EditImg />
          </button>
          {Role === Roles.admin && (
            <button
              onClick={() => handleOpenConvertToClientModal(row.original)}
              className="text-blue-500 hover:text-blue-700"
            >
              <ClientIcon />
            </button>
          )}
          <button
            onClick={() => navigate(`/lead/${row.original._id}`)}
            className="text-blue-600 hover:text-blue-800 relative"
          >
            {row.original.messageCount && row.original.messageCount > 0 ? (
              <span className="text-xs absolute bg-red-500 p-2 -right-1 text-white rounded-full w-3 h-3 flex items-center justify-center">
                {row.original.messageCount}
              </span>
            ) : null}
            <ViewFileImg />
          </button>
          <button
            onClick={() => {
              const leadUrl = `https://task.blisslers.com/lead/${row.original._id}`;
              copy(leadUrl);
              toast.success("Lead URL copied to clipboard!");
            }}
            className="text-green-600 hover:text-green-800"
          >
            <ShareIcon />
          </button>
        </div>
      ),
    },
  ];

  // State for selected CSV columns
  const [selectedCsvFields, setSelectedCsvFields] = useState<string[]>([
    ...DEFAULT_CSV_FIELDS,
  ]);

  // Map columns to CSV field names
  const columnFieldMap = useMemo(
    () => [
      { field: "No", headerName: "No" },
      { field: "LEADID", headerName: "Lead Web Link" },
      { field: "SERVICES", headerName: "SERVICES" },
      { field: "DESCRIPTION", headerName: "DESCRIPTION" },
      { field: "PHONE", headerName: "PHONE" },
      { field: "EMAIL", headerName: "EMAIL" },
      { field: "TEMPLATE", headerName: "TEMPLATE" },
      { field: "LEADID", headerName: "LEADID" },
      // Dynamically add from columns array (excluding those already mapped)
      ...columns
        .filter(
          (col) =>
            ![
              "No",
              "LEADID",
              "SERVICES",
              "DESCRIPTION",
              "CONTACT",
              "TEMPLATE",
              "TEMPLATEID",
            ].includes(col.header as string)
        )
        .map((col) => ({
          field: (col as any).accessorKey || (col as any).field || "",
          headerName: col.header as string,
        })),
    ],
    [columns]
  );

  // Handle checkbox change
  const handleCsvFieldChange = (headerName: string) => {
    setSelectedCsvFields((prev) =>
      prev.includes(headerName)
        ? prev.filter((f) => f !== headerName)
        : [...prev, headerName]
    );
  };

  const [selectedId, setSelectedId] = useState("");
  const [showPendingLeads, setShowPendingLeads] = useState(false);

  // Date filter function
  const getDateFilteredLeads = (leads: ILead[]) => {
    // If no date filter is applied, return all leads
    if (!dateFilter || dateFilter === "today") return leads;

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const lastWeek = new Date(today);
    lastWeek.setDate(lastWeek.getDate() - 7);

    const lastMonth = new Date(today);
    lastMonth.setMonth(lastMonth.getMonth() - 1);

    return leads.filter((lead) => {
      if (!lead.createdAt) return false;
      const leadDate = new Date(lead.createdAt);

      switch (dateFilter) {
        case "today":
          return (
            leadDate.getFullYear() === today.getFullYear() &&
            leadDate.getMonth() === today.getMonth() &&
            leadDate.getDate() === today.getDate()
          );
        case "yesterday":
          return (
            leadDate.getFullYear() === yesterday.getFullYear() &&
            leadDate.getMonth() === yesterday.getMonth() &&
            leadDate.getDate() === yesterday.getDate()
          );
        case "lastWeek":
          return leadDate >= lastWeek && leadDate <= today;
        case "lastMonth":
          return leadDate >= lastMonth && leadDate <= today;
        default:
          return true;
      }
    });
  };

  // Filter leads by selected service and pending status
  const filteredLeads = useMemo(() => {
    let leads = leadData;
    if (selectedService) {
      leads = leads.filter((lead) => {
        // Check both serviceActive and services.type to match the column logic
        const leadService =
          (lead.services?.type && lead.serviceActive) || lead.services?.type;
        return leadService === selectedService;
      });
    }
    if (platform) {
      leads = leads.filter((lead) => lead.platform?.name === platform);
    }

    if (showPendingLeads) {
      leads = leads.filter((lead) => lead.leadStatus === "New");
    }
    if (selectedAttendBy) {
      leads = leads.filter(
        (lead) =>
          lead.connectedId?._id === selectedAttendBy ||
          lead.connectedId?._id === selectedAttendBy
      );
    }
    // Apply date filter
    leads = getDateFilteredLeads(leads);
    return leads;
  }, [
    leadData,
    selectedService,
    showPendingLeads,
    selectedAttendBy,
    dateFilter,
    platform,
  ]);

  const handlePendingLeadsClick = () => {
    setShowPendingLeads((prev) => !prev);
  };

  // Local clear filters function that also resets date filter
  const handleClearFilters = () => {
    clearFilters();
    setDateFilter("today");
    setSelectedService("");
    setSelectedAttendBy("");
    setPlatform("");
    setShowPendingLeads(false);
  };

  // Fetch users for assignment dropdown
  const fetchUsers = async () => {
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: apiPaths.getAllEmployees,
      });
      setUsers(response.users || []);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  // Fetch projects for dropdown
  const fetchProjects = async () => {
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: apiPaths.getProjects,
      });
      setProjects(response || []);
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  // Load users and projects when component mounts
  useEffect(() => {
    fetchUsers();
    fetchProjects();
  }, []);

  return (
    <div>
      <div className="m-5 h-[80vh] overflow-auto">
        {loading && <Loader />}
        <div className="h-full">
          {selectedLeadId ? (
            <EditLeadIndex
              leadId={selectedLeadId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
              <Tabs labels={["Lead","Calendar", "My Leads", "Graph", "Goals", "Lead Tracker","Bed Form"]}>
                
                <div className="relative">
                  {/* Services Filter Dropdown */}
                  <div className="mb-3 flex items-center gap-3 bg-white p-3 rounded-lg border-b flex-shrink-0">
                    <div className="flex items-center gap-2 space-x-2 w-full flex-wrap">
                      <select
                        className="border rounded p-2 h-8 text-xs"
                        value={selectedService}
                        onChange={(e) => setSelectedService(e.target.value)}
                      >
                        <option value="">--Services--</option>
                        {services.map((service) => (
                          <option key={service.id} value={service.type}>
                            {service.type}
                          </option>
                        ))}
                      </select>
                      {/* Attend By Filter */}

                      <select
                        className="p-2 border rounded min-w-[100px] h-8 text-xs"
                        value={selectedAttendBy}
                        onChange={(e) => setSelectedAttendBy(e.target.value)}
                      >
                        <option value="">Attend By</option>
                        {user &&
                          user.map((u: IUsers) =>
                            u.id && u.name ? (
                              <option key={u.id} value={u.id}>
                                {u.name}
                              </option>
                            ) : null
                          )}
                      </select>
                      <select
                        className="p-2 border rounded"
                        value={platform}
                        onChange={(e) => setPlatform(e.target.value)}
                        disabled={!platforms || platforms.length === 0}
                      >
                        <option value="">--Platform--</option>
                        {platforms && platforms.length > 0 ? (
                          platforms.map((platform: any) => (
                            <option key={platform.id} value={platform.name}>
                              {platform.name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No platforms available
                          </option>
                        )}
                      </select>
                      {/* Date Filter */}
                      {/* <label className="font-medium ml-4">Lead Filter:</label> */}
                      <select
                        className="p-2 border rounded h-9 text-xs"
                        value={dateFilter}
                        onChange={(e) => setDateFilter(e.target.value)}
                      >
                        <option value="today">Today</option>
                        <option value="all">All</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="tomorrow">Tomorrow</option>
                        <option value="currentWeek">Current Week</option>
                        <option value="nextWeek">Next Week</option>
                        <option value="lastWeek">Last Week</option>
                        <option value="lastMonth">Last Month</option>
                        <option value="last7Days">Last 7 Days</option>
                        <option value="custom">Custom</option>
                      </select>

                      <button
                        onClick={handleRemainder}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 relative"
                        disabled={!csvStartDate || !csvEndDate}
                      >
                        Follow Up
                        {todayCount > 0 && (
                          <span className="absolute -top-1 -right-0 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                            {todayCount}
                          </span>
                        )}
                      </button>
                      <Button
                        type="button"
                        onClick={handlePendingLeadsClick}
                        className="px-2 py-1 bg-blue-500 text-white rounded text-xs w-28 h-8"
                      >
                        Pending Leads
                      </Button>
                      <button
                        onClick={handleClearFilters}
                        className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
                        title="Clear all filters and reset to default view"
                      >
                        Clear Filters
                      </button>
                      {/* <button
                            onClick={() => fetchPlatformsData("platform")}
                            className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                            title="Refresh platforms"
                          >
                            Refresh Platforms
                          </button> */}
                      <button
                        onClick={handleDownloadCSV}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                      >
                        Download CSV
                      </button>
                      <button
                    onClick={openImportModal}
                    className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    <Upload className="w-4 h-4 mr-2" />
                    Import CSV File
                  </button>
                    </div>
                  </div>

                  

                  <div className="flex items-center space-x-2 ">
                    {(Role === Roles.admin ||
                      currentSubRole === Roles.bde_manager) && (
                      <div className="flex items-center space-x-2 ml-5 mb-4 w-full justify-between">
                        <div className="flex items-center space-x-2 ">
                          {/* <CustomDropdown
                            label=""
                            options={status}
                            defaultOptionId={sortValue}
                            setDefaultOptionId={setSortValue}
                            displayProperty="name"
                            value={sortValue}
                            style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
                          /> */}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col sm:flex-row justify-between items-center w-full mb-5 px-5 gap-4">
                    <div className="flex gap-3">
                      <div className="w-40 mr-2 border rounded-md shadow-lg p-2 bg-white">
                        <p className="text-sm font-medium text-gray-500">
                          New Lead
                        </p>
                        <p className="text-2xl font-bold text-primary-2 text-blue-500">
                          {leadCount.newLead}
                        </p>
                      </div>
                      <div className="w-40 mr-2 border rounded-md shadow-lg p-2 bg-white">
                        <p className="text-sm font-medium text-gray-500">
                          Inprogress Lead
                        </p>
                        <p className="text-2xl font-bold text-primary-2 text-orange-500">
                          {leadCount.inProgress}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Table Container - Takes remaining space */}
                  <div className="flex-1 min-h-0 px-3 pb-3">
                    <div className="h-full">
                      <ModernTable
                        data={filteredLeads}
                        columns={columns}
                        loading={!leadData}
                        onSearch={setSearch}
                        onPageChange={setPage}
                        currentPage={page}
                        totalPages={totalPage}
                        onAdd={handleAdd}
                        searchValue={search}
                        title="Leads"
                        showSearch={true}
                        showPagination={true}
                        showAddButton={true}
                      />
                    </div>
                  </div>
                </div>
                <Calendar />
                <MyLeads leads={filteredLeads} />
                <GraphLead />
                <Goals />
                <LeadTracker />
                <BdeForm />
              </Tabs>
              {/* Import CSV Modal */}
              <Modal
                isOpen={isImportModalOpen}
                onClose={closeImportModal}
                style="max-w-2xl w-full mx-4"
              >
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-semibold text-gray-900">
                      Import CSV File
                    </h2>
                  </div>

                  {importStep === "upload" && (
                    <div className="space-y-6">
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                        <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          Upload CSV File
                        </h3>
                        <p className="text-gray-500 mb-4">
                          Select a CSV file with lead data. Make sure it follows the
                          template format. The first column should be LinkedIn profile
                          URLs.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-3 items-center justify-center">
                          <input
                            type="file"
                            accept=".csv"
                            onChange={handleFileSelect}
                            className="hidden"
                            id="csv-upload"
                          />
                          <label
                            htmlFor="csv-upload"
                            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 cursor-pointer transition-colors text-center"
                          >
                            Choose File
                          </label>
                        </div>
                      </div>
                    </div>
                  )}

                  {importStep === "preview" && (
                    <div className="space-y-6">
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <div className="flex items-center">
                          <FileText className="w-5 h-5 text-blue-600 mr-2" />
                          <span className="text-blue-800 font-medium">
                            File Preview
                          </span>
                        </div>
                        <p className="text-blue-700 text-sm mt-1">
                          Previewing first 5 rows of your CSV file
                        </p>
                        <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded">
                          <p className="text-yellow-800 text-xs">
                            <strong>Note:</strong> Ensure the linkedin field contains
                            valid LinkedIn URLs and the description field contains
                            meaningful content.
                          </p>
                        </div>
                      </div>

                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead className="bg-gray-50">
                            <tr>
                              {previewData[0] &&
                                Object.keys(previewData[0]).map((header) => (
                                  <th
                                    key={header}
                                    className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                                  >
                                    {header}
                                  </th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {previewData.map((row, index) => (
                              <tr key={index} className="border-t">
                                {Object.values(row).map((value, cellIndex) => (
                                  <td key={cellIndex} className="px-3 py-2 text-gray-900">
                                    {value || ""}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="flex justify-between">
                        <button
                          onClick={() => {
                            setImportStep("upload");
                            setSelectedFile(null);
                            setPreviewData([]);
                          }}
                          className="px-4 py-2 text-gray-600 hover:text-gray-800"
                        >
                          Back
                        </button>
                        <button
                          onClick={handleImport}
                          disabled={importLoading}
                          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                          {importLoading ? "Importing..." : "Import Data"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </Modal>
              <EmailModal
                isOpen={isEmailModalOpen}
                onClose={() => {
                  setIsEmailModalOpen(false);
                  setSelectedLeadForEmail(null);
                }}
                onSendMail={handleSendEmail}
                onSend={handleSendComment}
                leadStatus={
                  selectedLeadForEmail
                    ? leadData.find((lead) => lead._id === selectedLeadForEmail)
                        ?.leadStatus || ""
                    : ""
                }
                selectedCount={selectedLeadForEmail ? 1 : selectedRows.length}
                selectedLeadId={selectedLeadForEmail}
              />
              {showDeleteConfirmation && (
                <ConfirmationDialog
                  message="Are you sure! you want to delete this lead?"
                  onCancel={handleCancelDelete}
                  onConfirm={handleConfirmDelete}
                />
              )}
              {showConfirmation && (
                <ConfirmationDialog
                  message="Are you sure you want to convert this lead to client?"
                  onCancel={handleCancelStatusUp}
                  onConfirm={handleConfirmStatusUp}
                />
              )}
              <ConvertToClientModal
                isOpen={isConvertToClientModalOpen}
                onClose={handleCloseConvertToClientModal}
                leadData={selectedLeadForConversion}
              />
              
              {/* Description Modal */}
              <Modal
                isOpen={isDescriptionModalOpen}
                onClose={handleCloseDescriptionModal}
                style="w-96 max-h-96 overflow-y-auto"
              >
                <div className="mb-4">
                  <h3 className="text-lg font-semibold">Full Description</h3>
                </div>
                <div className="text-gray-700 whitespace-pre-wrap">
                  {selectedDescription}
                </div>
              </Modal>
              {/* Enhanced Reminder Popup */}
              {isReminderPopupOpen && selectedLeadForReminder && (
                <div className="fixed inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50 z-50">
                  <div className="bg-white p-6 rounded-lg shadow-md w-[600px] max-h-[90vh] overflow-y-auto">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-xl font-semibold text-gray-900">
                        Set Follow-up Reminder
                      </h3>
                      <button
                        onClick={handleCloseReminderModal}
                        className="text-gray-500 hover:text-gray-700 text-xl"
                      >
                        ✕
                      </button>
                    </div>

                    {/* Lead Information Display */}
                    <div className="bg-gray-50 p-4 rounded-lg mb-6">
                      <h4 className="font-medium text-gray-900 mb-3">Lead Information</h4>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <span className="font-medium text-gray-600">Name:</span>
                          <span className="ml-2 text-gray-900">{selectedLeadForReminder.name}</span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">Company:</span>
                          <span className="ml-2 text-gray-900">{selectedLeadForReminder.companyName || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">Email:</span>
                          <span className="ml-2 text-gray-900">{selectedLeadForReminder.email || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">Phone:</span>
                          <span className="ml-2 text-gray-900">{selectedLeadForReminder.phone || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">Service:</span>
                          <span className="ml-2 text-gray-900">{selectedLeadForReminder.services?.type || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">Platform:</span>
                          <span className="ml-2 text-gray-900">{selectedLeadForReminder.platform?.name || 'N/A'}</span>
                        </div>
                      </div>
                    </div>

                    {/* Reminder Form */}
                    <form onSubmit={(e) => { e.preventDefault(); handleReminderSubmit(); }}>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Reminder Title *
                          </label>
                          <input
                            type="text"
                            name="title"
                            value={reminderForm.title}
                            onChange={handleReminderFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter reminder title"
                            required
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Description *
                          </label>
                          <textarea
                            name="description"
                            value={reminderForm.description}
                            onChange={handleReminderFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter reminder description"
                            rows={3}
                            required
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Reminder Date & Time *
                          </label>
                          <DatePicker
                            selected={selectedReminderDate}
                            onChange={(date) => setSelectedReminderDate(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholderText="Select reminder date and time"
                            minDate={new Date()}
                            required
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Follow-up Date/Time
                          </label>
                          <input
                            type="datetime-local"
                            name="followupDateTime"
                            value={reminderForm.followupDateTime}
                            onChange={handleReminderFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Follow-up Notes
                          </label>
                          <textarea
                            name="followupNotes"
                            value={reminderForm.followupNotes}
                            onChange={handleReminderFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter follow-up notes"
                            rows={3}
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Assign To
                          </label>
                          <select
                            name="assignedTo"
                            value={reminderForm.assignedTo}
                            onChange={handleReminderFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="">Select User</option>
                            {users.map((user) => (
                              <option key={user._id} value={user._id}>
                                {user.name} ({user.email})
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Project (Optional)
                          </label>
                          <select
                            name="projectId"
                            value={reminderForm.projectId}
                            onChange={handleReminderFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="">Select Project</option>
                            {projects.map((project) => (
                              <option key={project._id} value={project._id}>
                                {project.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="flex justify-end gap-3 mt-6">
                        <button
                          type="button"
                          onClick={handleCloseReminderModal}
                          className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          disabled={creatingReminder || !selectedReminderDate}
                          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center space-x-2"
                        >
                          {creatingReminder ? (
                            <>
                              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                              <span>Creating...</span>
                            </>
                          ) : (
                            <>
                              <span>✓</span>
                              <span>Set Reminder</span>
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              {isDownloadModalOpen && (
                <div className="fixed inset-0 flex  justify-center items-center bg-gray-700 bg-opacity-50 z-50">
                  <div className="bg-white p-5 rounded-lg shadow-md w-[50vw]">
                    <h3 className="text-lg font-semibold mb-4">
                      Select Date Range and Options for CSV Download
                    </h3>
                    <div className="flex gap-5">
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Start Date
                          </label>
                          <DatePicker
                            selected={csvStartDate}
                            onChange={(date) => setCsvStartDate(date)}
                            selectsStart
                            startDate={csvStartDate}
                            endDate={csvEndDate}
                            className="w-full p-2 border rounded-lg"
                            placeholderText="Select start date"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            End Date
                          </label>
                          <DatePicker
                            selected={csvEndDate}
                            onChange={(date) => setCsvEndDate(date)}
                            selectsEnd
                            startDate={csvStartDate}
                            endDate={csvEndDate}
                            minDate={csvStartDate}
                            className="w-full p-2 border rounded-lg"
                            placeholderText="Select end date"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Platform Filter
                          </label>
                          <select
                            className="w-full p-2 border rounded-lg"
                            value={platform}
                            onChange={(e) => setPlatform(e.target.value)}
                          >
                            <option value="">All Platforms</option>
                            {platforms && platforms.length > 0 ? (
                              platforms.map((plat: any) => (
                                <option key={plat.id} value={plat.name}>
                                  {plat.name}
                                </option>
                              ))
                            ) : null}
                          </select>
                          <p className="text-xs text-gray-500 mt-1">
                            {platform ? `Filter by: ${platform}` : 'Download all platforms'}
                          </p>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 max-h-60 overflow-y-auto">
                        {columnFieldMap.map((heading) => (
                          <ul
                            key={heading.headerName}
                            className="grid grid-cols-2 w-70 h-fit"
                          >
                            <li className="m-1 space-x-2">
                              <input
                                type="checkbox"
                                checked={selectedCsvFields.includes(
                                  heading.headerName
                                )}
                                onChange={() =>
                                  handleCsvFieldChange(heading.headerName)
                                }
                                id={`csv-field-${heading.headerName}`}
                              />
                              <label
                                htmlFor={`csv-field-${heading.headerName}`}
                              >
                                {heading.headerName}
                              </label>
                            </li>
                          </ul>
                        ))}
                      </div>
                    </div>
                    <div className="flex justify-end gap-3 mt-4">
                      <button
                        onClick={handleCancelDownload}
                        className="px-4 py-2 text-gray-600 hover:text-gray-800"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => handleConfirmDownload(selectedCsvFields, platform)}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        disabled={!csvStartDate || !csvEndDate}
                      >
                        Download {platform ? `(${platform})` : '(All)'}
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {isSequenceModalOpen && (
                <div className="fixed inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50 z-50">
                  <div className="bg-white p-5 rounded-lg shadow-md w-96">
                    <h3 className="text-lg font-semibold mb-4">
                      Add to Sequence
                    </h3>
                    <div className="mb-3">
                      <label className="block text-sm font-medium mb-1">
                        Sequence
                      </label>
                      <select
                        className="w-full p-2 border rounded-lg"
                        value={selectedSequence}
                        onChange={(e) => setSelectedSequence(e.target.value)}
                      >
                        <option value="">Select Sequence</option>
                        {sequences.map((seq: any) => (
                          <option key={seq.id} value={seq.id}>
                            {seq.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="block text-sm font-medium mb-1">
                        Email From
                      </label>
                      <select
                        className="w-full p-2 border rounded-lg"
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.target.value)}
                      >
                        <option value="">Select User</option>
                        {userNames.map((u: any) => (
                          <option key={u.id} value={u.id}>
                            {u.name}({u.email})
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Pre-filled fields */}
                    <div className="mb-2">
                      <label className="block text-xs">First Name</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="first_name"
                        value={modalFields.first_name}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Last Name</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="last_name"
                        value={modalFields.last_name}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Organization Name</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="organization_name"
                        value={modalFields.organization_name}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Title</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="title"
                        value={modalFields.title}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Email</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="email"
                        value={modalFields.email}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Website URL</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="website_url"
                        value={modalFields.website_url}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Direct Phone</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="direct_phone"
                        value={modalFields.direct_phone}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-xs">Corporate Phone</label>
                      <input
                        className="w-full p-1 border rounded"
                        name="corporate_phone"
                        value={modalFields.corporate_phone}
                        onChange={handleModalFieldChange}
                      />
                    </div>
                    <div className="flex justify-end gap-3 mt-4">
                      <button
                        onClick={() => setIsSequenceModalOpen(false)}
                        className="px-4 py-2 text-gray-600 hover:text-gray-800"
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleCreateContact}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        disabled={
                          isSubmitting || !selectedSequence || !selectedUser
                        }
                      >
                        {isSubmitting ? "Submitting..." : "Create Contact"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Lead;
